import { lazyRouteComponent } from "@tanstack/react-router";
import { Map as MapIcon } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const pages: PageDef[] = [
  {
    path: "/app/market-atlas",
    proOnly: true,
    title: "Market Atlas",
    component: lazyRouteComponent(
      () => import("./MarketAtlasPage"),
      "MarketAtlasPage",
    ),
    nav: { label: "Market Atlas", icon: MapIcon, group: "Premium", order: 8 },
  },
];
